module.exports = __webpack_public_path__ + "img/Marukoma_title.9a177ff1.png";